import f from 'odata-filter-builder';
import { transformODataResponse } from 'utilities/query';
import templateUrl from './company-autocomplete.html';

export default {
  templateUrl,
  bindings: {
    isRequired: '<',
    onCompanySelected: '&'
  },
  controller: class CompanyAutocomplete {
    constructor(EventEmitter, CompanyService) {
      'ngInject';

      Object.assign(this, {
        EventEmitter,
        CompanyService
      });
    }

    searchCompanies(name) {
      return this.CompanyService.search({
        ...this.CompanyService.getDefaultQuery(),
        filter: f().and(x => x.contains('MemberName', name))
      }).then(r => transformODataResponse(r).Data);
    }

    selectedCompanyChanged(selectedCompany) {
      this.onCompanySelected(
        this.EventEmitter({
          company: selectedCompany
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/autocomplete/company/company-autocomplete.component.js